import React from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";

import "./ContentFeedAssignedCreatives.css";

export default function ContentFeedAssignedCreatives({ dependentValues }) {
	const dispatch = useDispatch();
	const { creativeCount, contentFeedName, contentFeedId, libraryId } = dependentValues;

	const handleClick = () => {
		dispatch(push({
			pathname: `/library/${libraryId}/content-feeds/modal/assigned-creatives/${contentFeedId}/`,
			state: {
				creativeCount,
				contentFeedName,
			},
		}));
	};

	if (creativeCount === 0) {
		return <span className="no-assigned-creatives">-</span>;
	}

	return (
		<div
			className="assigned-creative-link"
			onClick={handleClick}
			role="button"
			tabIndex={0}
		>
			{creativeCount}
		</div>
	);
}

ContentFeedAssignedCreatives.displayName = "ContentFeedAssignedCreatives";

